import { compose } from 'recompose';
import DamageExpiryValuation from './DamageExpiryValuation';
import apiInterceptor from '../../../api/interceptor';
import { stockValuationReportApi } from '../../common/base.api';

const composedDamageExpiryValuation = compose(apiInterceptor({ ...stockValuationReportApi }))(DamageExpiryValuation);
export default composedDamageExpiryValuation;
